import type { FlagKey, FlagRecord } from "@/hooks/useFeatureFlags/flags";

export const BACKGROUND_CHECK_STAFF_VISIBILITY_FLAG = "backoffice-background-check-staff-visibility" satisfies FlagKey;
export const BACKGROUND_CHECK_STAFF_SEND_INVITATION_FLAG =
  "backoffice-background-check-staff-send-invitation" satisfies FlagKey;
export const BACKGROUND_CHECK_STAFF_CREATE_ORDER_FLAG =
  "backoffice-background-check-staff-create-order" satisfies FlagKey;
export const BACKGROUND_CHECK_DISPOSITION_EDIT_FLAG = "backoffice-bgc-staff-disposition-edit" satisfies FlagKey;

type BackgroundCheckFlags = FlagRecord;

function flagOn(flags: BackgroundCheckFlags, key: FlagKey): boolean {
  return Boolean(flags[key]);
}

export function canViewBackgroundCheckStaffSection(options: {
  flags: BackgroundCheckFlags;
  canViewPartialBackgroundCheck: boolean;
}): boolean {
  return flagOn(options.flags, BACKGROUND_CHECK_STAFF_VISIBILITY_FLAG) && options.canViewPartialBackgroundCheck;
}

export function canSendBackgroundCheckStaffInvitation(options: {
  flags: BackgroundCheckFlags;
  staffSectionVisible: boolean;
  canManageBackgroundCheck: boolean;
}): boolean {
  return (
    options.staffSectionVisible &&
    flagOn(options.flags, BACKGROUND_CHECK_STAFF_SEND_INVITATION_FLAG) &&
    options.canManageBackgroundCheck
  );
}

export function canCreateBackgroundCheckStaffOrder(options: {
  flags: BackgroundCheckFlags;
  staffSectionVisible: boolean;
  canManageBackgroundCheck: boolean;
}): boolean {
  return (
    canSendBackgroundCheckStaffInvitation(options) && flagOn(options.flags, BACKGROUND_CHECK_STAFF_CREATE_ORDER_FLAG)
  );
}

export function canEditBackgroundCheckDispositionOnProspectProgram(options: {
  flags: BackgroundCheckFlags;
  canManageBackgroundCheck: boolean;
}): boolean {
  return (
    flagOn(options.flags, BACKGROUND_CHECK_DISPOSITION_EDIT_FLAG) &&
    options.canManageBackgroundCheck &&
    !flagOn(options.flags, BACKGROUND_CHECK_STAFF_VISIBILITY_FLAG)
  );
}

export function canEditBackgroundCheckRequirementOnPtm(options: {
  flags: BackgroundCheckFlags;
  canManageBackgroundCheck: boolean;
}): boolean {
  return flagOn(options.flags, BACKGROUND_CHECK_DISPOSITION_EDIT_FLAG) && options.canManageBackgroundCheck;
}
